import { mainFetch } from "../mainFetch";

const SERVICE_URL = '/shipment/realization'

const fetchService = async ({ url, ...params }) =>
    await mainFetch({ url: SERVICE_URL + url, ...params })
        .catch(e => { console.log(e); throw (e) });

export default class RealizationApi {

    static async getRealizations({ data = { market: undefined, dateRealization: undefined, realizationType: undefined, isExpress: undefined, status: undefined, limit: undefined, page: undefined }, ...params }) {
        return await fetchService({ url: '/getrealizations', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async getRealizedPostings({ data = {
        tab: undefined, pageName: undefined, realizationIds: undefined, market: undefined, shop: undefined, shipmentFilter: undefined,
        providerId: undefined, search: undefined, ipFilter: undefined, filters: undefined, period: undefined, limit: undefined, page: undefined, saleSchema: undefined, sortType: undefined
    }, ...params }) {
        return await fetchService({ url: '/getrealizedpostings', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async changeRealization({ data = { realizationId: undefined, field: undefined, value: undefined }, ...params }) {
        return await fetchService({ url: '/changerealization', method: 'PATCH', data, ...params })
    }


    static async move45({ data = { realizationIds: undefined, }, ...params }) {
        return await fetchService({ url: '/move45', method: 'POST', data, ...params })
    }


    static async reserveStocksForPostings({ data = { realizationIds: undefined, postingNumbers: undefined, ignoreDiffPrices: undefined, saleSchema: undefined }, ...params }) {
        return await fetchService({ url: '/reservestocks', method: 'POST', data, ...params })
    }

    static async reportOp1Op2({ data = { pageName: undefined, operation_1c: undefined, tab: undefined, type: undefined, market: undefined, shop: undefined, realizationIds: undefined, providerId: undefined, ipFilter: undefined, search: undefined, filters: undefined, period: undefined }, ...params }) {
        return await fetchService({ url: '/excelrealization', method: 'POST', data, options: { download: true }, ...params })
    }

    static async excelProductsInRealization({ data = { pageName: undefined, tab: undefined, saleSchema: undefined, type: undefined, market: undefined, ipFilter: undefined, shop: undefined, realizationIds: undefined, providerId: undefined, search: undefined, filters: undefined, period: undefined }, ...params }) {
        return await fetchService({ url: '/exceldata', method: 'POST', data, options: { download: true }, ...params })
    }



    // static async updatePrices({ data = { pageName: undefined, tab: undefined, saleSchema: undefined, type: undefined, market: undefined, ipFilter: undefined, shop: undefined, realizationIds: undefined, providerId: undefined, search: undefined, filters: undefined, period: undefined }, ...params }) {
    //     return await fetchService({ url: '/updateprices', method: 'POST', data, ...params })
    // }

    static async resale({ data = { operation1c: undefined, pageName: undefined, realizationIds: undefined, tab: undefined, sortType: undefined, market: undefined, shop: undefined, ipFilter: undefined, shipmentFilter: undefined, providerId: undefined, search: undefined, filters: undefined, period: undefined, limit: undefined, page: undefined }, ...params }) {
        return await fetchService({ url: '/resale', method: 'POST', data, ...params })
    }

    // static async unoResale({ data = { historyId: undefined }, ...params }) {
    //     return await fetchService({ url: '/unoresale', method: 'POST', data, ...params })
    // }

}